<template>
    <div>
        <div class="list all-center">
            <div class="content-item">
                <div class="header -one">累计协议成交</div>
                <div class="content -one">
                    <div class="label">金额</div>
                    <div class="number">
                        {{ info.agreementSumCosts
                        }}<span class="unit">{{
                            info.agreementSumCostsCompany
                        }}</span>
                    </div>
                </div>
                <div class="content">
                    <div class="label">笔数</div>
                    <div class="number">
                        {{ $toTnteger(info.agreementNumber) || 0
                        }}<span class="unit">笔</span>
                    </div>
                </div>
            </div>
            <div class="content-item -two">
                <div class="header -two">累计竞拍成交</div>
                <div class="content -one">
                    <div class="label">金额</div>
                    <div class="number">
                        {{ info.auctionSumCosts
                        }}<span class="unit">{{
                            info.auctionSumCostsCompany
                        }}</span>
                    </div>
                </div>
                <div class="content">
                    <div class="label">笔数</div>
                    <div class="number">
                        {{ $toTnteger(info.auctionNumber) || 0
                        }}<span class="unit">笔</span>
                    </div>
                </div>
            </div>
            <div class="content-item -two">
                <div class="header -three">累计交易金额</div>
                <div class="content -one">
                    <div class="label">金额</div>
                    <div class="number">
                        {{ info.sumCosts
                        }}<span class="unit">{{ info.sumCostsCompany }}</span>
                    </div>
                </div>
                <div class="content">
                    <div class="label">笔数</div>
                    <div class="number">
                        {{ $toTnteger(info.sumNumber) || 0
                        }}<span class="unit">笔</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as fcScreenAPI from '@/api/fc-screen'
import eventHub from '@/utils/eventHub'

/**
 * 交易情况
 */
export default {
    data() {
        return {
            info: {
                agreementSumCosts: '0.0', // 累计协议成交金额
                agreementSumCostsCompany: '', // 累计协议成交金额单位
                agreementNumber: 0, // 累计协议成交笔数

                auctionSumCosts: '0.0', // 累计竞拍成交金额
                auctionSumCostsCompany: '', // 累计竞拍成交金额单位
                auctionNumber: 0, // 累计竞拍成交笔数

                sumCosts: '0.0', // 累计交易金额
                sumCostsCompany: '', // 累计交易接单位
                sumNumber: 0 // 累计交易笔数
            }
        }
    },
    methods: {
        async getTotalSummary(cId) {
            const params = {
                locCounty: 1565,
                locTown: cId
            }
            const response = await fcScreenAPI.getTransactionData(params)
            this.info = response.data
        }
    },
    mounted() {
        eventHub.$on('areaChange', (cId) => {
            this.getTotalSummary(cId)
        })
    }
}
</script>

<style lang="scss" scoped>
.list {
    margin: 20px auto 0;
    padding: 0 32px;
    width: calc(100% - 20px);
    display: flex;
    justify-content: space-between;
}
.content-line {
    width: 1px;
    background: #fff;
    height: 80px;
}
._content-item-two {
    padding: 25px 40px 10px 100px !important;
}
._content-item-three {
    padding: 25px 40px 10px 50px !important;
}
.content-item {
    position: relative;
    flex: 1;
    &.-two {
        margin-left: 4px;
        padding-left: 18px;
        box-sizing: border-box;
        &::after {
            content: '';
            position: absolute;
            height: 80px;
            top: 20px;
            width: 1px;
            background-color: #495f78;
        }
        &::after {
            left: 0;
        }
        &::before {
            right: 0;
        }
    }
    > .header {
        height: 29px;
        background-position: left top;
        background-repeat: no-repeat;
        background-size: 25px 25px;
        padding-left: 36px;
        font-size: 15.49px;
        color: #ffffff;
        letter-spacing: 0.12px;
        line-height: 26px;
        margin-bottom: 10px;
        white-space: nowrap;
        &.-one {
            background-image: url('../../../assets/images/auction.png');
        }

        &.-two {
            background-image: url('../../../assets/images/agreement.png');
        }

        &.-three {
            background-image: url('../../../assets/images/history.png');
        }

        &.-four {
            background-image: url('../../../assets/images/total.png');
        }
    }
    > .content {
        line-height: 28px;
        display: flex;
        align-items: center;
        margin-left: 4px;
        &.-one {
            margin-bottom: 4px;
        }
        > .label {
            font-size: 16px;
            color: #fff;
            line-height: 28px;
            flex-shrink: 0;
        }
        > .number {
            margin-left: 8px;
            font-size: 18px;
            color: #ffa106;
            letter-spacing: 0.08px;
            font-weight: 600;
            font-family: PingFangSC-Semibold;
            white-space: nowrap;
            > .unit {
                font-family: PingFangSC-Regular;
                letter-spacing: 0;
                font-size: 14px;
                font-weight: normal;
                margin-left: 8px;
                vertical-align: baseline;
                color: #fff;
            }
        }
    }
}
</style>
